const { bimbelConfig } = require("./appConfig");
const activeBimbel = process.env.VUE_APP_BIMBEL;
const isPriorityBrand = activeBimbel === "priority";
const appLogoFile = isPriorityBrand ? "logo-wordmark.png" : "logo.svg";
const appLogoMarkFile = isPriorityBrand ? "logo-mark.png" : appLogoFile;

// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: bimbelConfig[process.env.VUE_APP_BIMBEL].appName,
    // eslint-disable-next-line global-require
    appLogoImage: require(`@public/config/${activeBimbel}/${appLogoFile}`),
    // eslint-disable-next-line global-require
    appLogoMarkImage: require(`@public/config/${activeBimbel}/${appLogoMarkFile}`),
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}
